import { FC } from 'react';

import { Box, Button, Separator } from '@base-app';
import { ArrowLeftIcon, StyledButtonContainer, StyledPageLargeTitle, StyledSubPage } from './SubPage.styles';
import { SubPageProps } from './SubPage.types';
import { Variants } from '@/common/types';
import { useNavigate } from 'react-router-dom';

const SubPage: FC<SubPageProps> = ({ backButton, children, header, hasSeparator, title, ...rest }) => {
  const navigate = useNavigate();

  const handleBackButton = (): void => {
    const path = backButton?.url ?? '-1';

    navigate(path);
  };

  return (
    <Box {...rest}>
      <StyledSubPage>
        {backButton && (
          <StyledButtonContainer>
            <Button
              css={{
                alignItems: 'center',
                display: 'flex',
                height: '$3',
              }}
              variant={Variants.SECONDARY}
              onClick={handleBackButton}
            >
              <ArrowLeftIcon />
              {backButton.label}
            </Button>
          </StyledButtonContainer>
        )}
        {title && (
          <StyledPageLargeTitle data-testid="page-large-title">
            <Box>{title}</Box>
          </StyledPageLargeTitle>
        )}
        {header && <Box data-testid="sub-page-header">{header}</Box>}
        <Box data-testid="sub-page-content">{children}</Box>
      </StyledSubPage>
      <Box data-testid="sub-page-separator" css={{ padding: '$4 0' }}>
        {hasSeparator && <Separator />}
      </Box>
    </Box>
  );
};

export default SubPage;
